<template>
<div title="Story Atelier Navigation" class="imgparent">
    <div v-for='(key, value) in movies' v-bind:key="key.img" v-on:click="setVideo($event)" class="imgbar">
        <img :title="key.name" :src="'/img/storyatelier/' + key.img" :data-src="value" />
    </div>
</div>
</template>

<style scoped>

.imgparent{
  margin-top: 10vh;
  overflow:scroll;
  direction: rtl;
  overflow-x: hidden;
  margin-left:-18px;
  height:80vh;
}

.imgbar, .imgbar img{
  cursor: pointer;
  margin-bottom:10px;
  width:200px;
  height:150px;
}

@media (orientation:portrait){
  .imgparent{
    display:flex;
    flex-wrap: wrap;
    margin-top:1vh;
    margin-left:0px;
    justify-content:center;
    height:auto;
    direction:ltr;
    width:100%;
    text-align: center;
  }

  .imgbar{
    width:auto;
    height:auto;
  }

  .imgbar img{
    flex-grow: 1;
    display:inline-block;
    height:115px;
    width:150px;
    margin-bottom:-1px;
    margin-left:7.5px;
    margin-right:7.5px;
  }
}



@media (orientation: landscape) and (max-width:981px){

.imgparent{
  margin-top: 5vh;
  height:90vh;
}

.imgbar, .imgbar img{
  margin-bottom:10px;
  width:125px;
  height:90px;
}

}

</style>

<script>
import s3data from '../../json/storyatelier.json'
export default {
  name: 'STnav',
  data () {
    return {
      movies: s3data
    }
  },
  methods: {
    setVideo: function ($event) {
      if (this.noClickValue === false) {
        document.getElementsByTagName('video')[0].src = '/videos/StoryAtelier/' + s3data[$event.target.dataset.src].url
        document.getElementsByTagName('video')[0].play()
      }
    }
  },
  computed: {
    noClickValue () {
      return this.$store.state.noClickValue
    }
  },
  props: {
    msg: String
  }
}
</script>
